import { cloneDeep } from 'lodash'
import { StoreLanguagesType } from '~/shared/api/services/stores/types'
import { LocalizationsType } from '~/shared/api/services/types'

export const mapToFilteredLocalization = (
  localizations: LocalizationsType,
  availableLanguages: StoreLanguagesType[],
) => {
  const synchronizedLocalizations = cloneDeep(localizations)
  const existingLanguageCodes = Object.keys(synchronizedLocalizations)

  existingLanguageCodes.forEach((key) => {
    const found = availableLanguages.find((el) => el.code === key)

    if (!found) {
      delete synchronizedLocalizations[key]
    }
  })

  availableLanguages.forEach((l) => {
    const found = existingLanguageCodes.find((el) => el === l.code)
    if (!found) {
      synchronizedLocalizations[l.code] = {
        name: '',
      }
    }
  })

  return synchronizedLocalizations
}
